import { render } from "./TanHuaPage.vue?vue&type=template&id=69c30b96&scoped=true"
import script from "./TanHuaPage.vue?vue&type=script&lang=js"
export * from "./TanHuaPage.vue?vue&type=script&lang=js"

import "./TanHuaPage.vue?vue&type=style&index=0&id=69c30b96&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69c30b96"]])

export default __exports__